export const GroupSummarySkeleton = () => {
  return (
    <>
      <h2 className="text-base font-bold mb-4">Group Summary</h2>

      <div className="grid grid-cols-4 gap-4 mb-8">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="py-3 pl-4 pr-11 relative min-h-[100px] flex flex-col justify-between bg-card rounded shadow border border-foreground-strong"
          >
            {/* icon placeholder */}
            <div className="absolute right-0 top-0 size-5 bg-border-strong animate-pulse" />

            {/* top row */}
            <div className="flex justify-between items-start">
              <div className="space-y-1">
                <div className="h-3 w-16 bg-border-strong rounded animate-pulse" />
                <div className="h-3 w-20 bg-border-strong rounded animate-pulse" />
              </div>

              <div className="h-3 w-10 bg-border-strong rounded animate-pulse" />
            </div>

            {/* value */}
            <div className="flex items-end gap-2">
              <div className="h-10 w-16 bg-border-strong rounded animate-pulse" />
              <div className="h-5 w-6 bg-border-strong rounded animate-pulse mb-1" />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
